/**
 * CMS Admin Page — Router Redirect to Static Decap CMS Portal
 *
 * Redirects the client directly to the static /admin/index.html bundle
 * where Decap CMS initializes independently of the main React router,
 * completely decoupled from Sanity.io.
 */

import { useEffect } from 'react';

export function CMSAdmin() {
  useEffect(() => {
    // Navigate directly to static index file to bypass Vite React router matching
    window.location.href = '/admin/index.html';
  }, []);

  return (
    <div className="min-h-screen bg-[#0f172a] flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <h1 className="text-3xl font-bold text-white mb-4">Loading Admin Portal</h1>
        <p className="text-white/80 mb-6">
          Initializing Netlify/Decap CMS Content Manager dashboard. Please wait...
        </p>
        <div className="inline-block size-8 animate-spin rounded-full border-4 border-solid border-white border-r-transparent align-[-0.125em] motion-reduce:animate-[spin_1.5s_linear_infinite]" />
      </div>
    </div>
  );
}

export default CMSAdmin;
